'use client'
import React, {useEffect, useRef, useState} from 'react';
import styled from "styled-components";
import {Container, Row, Col, Table} from "react-bootstrap";
import {grayText, hover, light, medium, text} from "@/styles/globalStyleVars";
import {Img} from "@/components/Img";
import Gallery from "@/components/Gallery";
import parser from "html-react-parser";
import Link from "next/link";
import {usePathname} from "next/navigation";
import {CURSOR_TEXT, DispatchCursor} from "haspr-cursor";
import gsap from "gsap"
import ScrollTrigger from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)
const MyComponent = ({data}) => {

    const [width, setWidth] = useState(0)
    const location = usePathname()
    useEffect(() => {
        setWidth(window.innerWidth)
    }, [])
    //
    //
    useEffect(() => {
        ScrollTrigger.refresh();
        // Scroll to top when page changes
        window.scrollTo(0, 1);
    }, [location]);
    //

    const dispatch = DispatchCursor()


    return (
        <StyledComponent  className={`detail-page ${ data?.page_data?.[0]?.gallery?.list?.length > 0 ? '' : 'pb-160'}`}>
            <Container  >
                <Row>
                    <Col sm={{span:9,offset:3}}>
                        <div className={'top-title'}>
                            {
                                data?.page_data?.[0]?.type?.[0]?.name &&
                                <p>{parser(data?.page_data?.[0]?.type?.[0]?.name)}</p>

                            }
                            <span className={'dot'}/>
                            {
                                data?.page_data?.[0]?.banner?.date &&
                                <p>{parser(data?.page_data?.[0]?.banner?.date)}</p>
                            }
                        </div>
                        <h4>{parser(data?.page_data?.[0]?.post_title)}</h4>
                    </Col>
                </Row>
            </Container>
            {
                data?.page_data?.[0]?.banner?.image &&
                <div className={'detail-page__img parallax'}>
                    <Img parallax src={data?.page_data?.[0]?.banner?.image}/>
                </div>

            }

            <Container onMouseEnter={() =>  CURSOR_TEXT(dispatch, 'END')}  className={'detail-page__text-content'}>
                <Row>
                    <Col sm={2} xs={9} className={'detail-page__address'}>

                        {
                            data?.page_data?.[0]?.address?.info &&
                            <>
                                <p>Address</p>
                                <Link href={data?.page_data?.[0]?.address?.map} target={'_blank'}>{parser(data?.page_data?.[0]?.address?.info)}</Link>
                            </>
                        }


                    </Col>
                    <Col sm={{span: 9,offset:1}} className={'detail-page__text-content__detail'}>
                        <div className={'full-detail'}>
                            {
                                data?.page_data?.[0]?.post_content &&
                                parser(data?.page_data?.[0]?.post_content)
                            }
                       </div>

                    </Col>
                </Row>
            </Container>

            {
                data?.page_data?.[0]?.gallery?.list && data?.page_data?.[0]?.gallery?.list?.length > 0 &&
                <Gallery data={data?.page_data?.[0]?.gallery}/>

            }



        </StyledComponent>
    );
};

const StyledComponent = styled.section`
    background: #FAFAFA;
    padding-top: 160px;

    h4 {
        margin-bottom: 40px;
    }

    .top-title {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        p {
            font-size: 12px;
            line-height: normal;
            font-family: ${light};
            font-weight: 300;
        }

        .dot {
            width: 6px;
            height: 6px;
            background-color: ${text};
            border-radius: 50%;
            z-index: 9999999;
            margin: 0px 10px;
        }
    }

    .detail-page__address {
        margin-bottom: 30px;

        a {
            font-size: 12px;
            font-weight: 300;
            line-height: 21px;
            text-align: left;
            color: #131719;    
        }

        p {
            margin-bottom: 10px;
            font-size: 12px;
            font-weight: 500;
            line-height: 21px;
            text-align: left;
        }
    }


    .detail-page__img {
        position: relative;
        padding-top: calc(600 / 1366 * 100%);

        @media (max-width: 767px) {
            padding-top: calc(560 / 375 * 100%);
        }
    }

    h5 {
        margin-bottom: 20px;
    }


    .detail-page__heading {
        h1 {
            font-size: 32px;
            line-height: 36px;
            color: #ED5333;
            font-weight: 600;
        }

        &__tags {
            margin-top: 40px;
            display: flex;
            justify-content: space-between;
            margin-bottom: 20px;

            p {
                color: ${hover};
                font-size: 16px;
                line-height: 24px;
            }

            ul {
                display: flex;

                li {

                    font-size: 16px;
                    line-height: 24px;
                    color: ${hover};

                    &:not(:nth-last-child(1)) {
                        padding-right: 20px;
                        margin-right: 20px;
                        border-right: 0;
                        border-right: 1px solid #CED7ED;
                    }
                }
            }
        }

    }

    .detail-page__banner {
        width: 100%;

        img {
            width: 100%;
            object-fit: cover;
        }
    }

    .hover:after {
        border-radius: 50%;
    }

    .detail-page__text-content {
        padding-top: 40px;

        &__share {
            .mobile-share {
                display: none;
            }


            @media (max-width: 767px) {
                //border-bottom: 1px solid rgba(217, 217, 217, 0.5) !important;
                .mobile-share {
                    display: flex;
                    justify-content: space-between;
                    width: 100%;
                    border-bottom: 1px solid rgba(217, 217, 217, 0.5) !important;
                }

            }
            @media (max-width: 767px) {
                //border-bottom: 1px solid rgba(217, 217, 217, 0.5) !important;
                .mobile-share {
                    display: flex;
                    justify-content: space-between;
                    width: 100%;
                    border-bottom: 1px solid rgba(217, 217, 217, 0.5) !important;
                    display: none;

                }

                .sticky-outer-wrapper {
                    display: none;
                }
            }


            p {
                color: #56575A;
                margin-bottom: 20px;
                font-weight: 500 !important;
                text-transform: uppercase;
            }

            ul {
                li {
                    min-height: 30px;
                    height: 30px;
                    width: 30px;
                    min-width: 30px;
                    border-radius: 50%;
                    background-color: ${grayText};
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    //cursor: pointer;
                    margin-bottom: 20px;
                    position: relative;

                    button {
                        position: absolute;
                        height: 100%;
                        width: 100%;
                        z-index: 2;
                    }

                    svg {
                        position: relative;
                        z-index: 2;
                    }
                }
            }

            @media (max-width: 767px) {
                display: flex;
                justify-content: space-between !important;
            }
        }

        &__detail {
            p {
                letter-spacing: 0;
            }

            .custom-list {
                padding: 0;

                li {

                    position: relative;
                    padding-left: 20px;
                    //padding-top: 20px;

                    &:not(:last-child) {
                        padding-bottom: 0px;
                    }

                    &:before {
                        content: '';
                        position: absolute;
                        top: 12px;
                        left: 0;
                        margin-top: -5px;
                        width: 8px;
                        height: 8px;
                        box-sizing: content-box;
                        background-color: ${hover};
                    }
                }

            }

            img {
                width: 100%;
            }

            span {
                p {
                    color: ${hover};
                    font-weight: 500;
                    margin-top: 20px;
                }
            }

            &__date {
                display: flex;
                justify-content: space-between;


                p {
                    font-weight: 500 !important;
                    font-size: 16px;
                    line-height: 24px;
                    margin-bottom: 20px !important;
                    text-transform: uppercase;
                }

                @media (max-width: 767px) {
                    display: block;
                    p {
                        &:not(last-child) {
                            margin-bottom: 10px !important;
                        }
                    }
                }
            }

            h1 {
                font-size: 40px;
                line-height: 48px;
                font-weight: 500;
                padding-bottom: 60px;
                //border-bottom: 1px solid #56575A;
                margin-bottom: 60px;

                @media (max-width: 767px) {
                    font-size: 32px;
                    line-height: 40px;
                    margin-top: 40px;
                }
            }

            h2 {
                font-size: 28px;
                line-height: 36px;
                font-weight: 500;
                margin-bottom: 20px;
            }

            p {
                font-weight: 400;
            }

            .quotes {
                padding-left: 40px;
                position: relative;
                margin-bottom: 40px;

                &:after {
                    content: '';
                    position: absolute;
                    width: 10px;
                    height: 100%;
                    left: 0;
                    top: 0;
                    background-color: ${hover};
                    border-radius: 5px;
                }

                h6 {
                    margin-top: 30px;
                    font-weight: 500;
                    color: ${text};
                }
            }

            table {
                min-width: 100%;
                margin-bottom: 30px;


                th {
                    color: ${hover};
                    border-bottom: 1px solid ${text};
                    padding: 20px 0;
                    font-weight: 500 !important;
                }

                td {
                    padding: 20px 0;
                    border-bottom: 1px solid rgba(86, 87, 90, 0.2);

                    &:nth-of-type(1) {
                        padding-right: 200px;
                        @media (max-width: 767px) {
                            padding-right: 30px;
                        }
                    }
                }
            }

            .custom-list {
                padding: 0;

                li {

                    position: relative;
                    padding-left: 20px;
                    padding-top: 20px;

                    &:not(:last-child) {
                        padding-bottom: 20px;
                        border-bottom: 1px solid rgba(86, 87, 90, 0.2);
                    }

                    &:before {
                        content: '';
                        position: absolute;
                        top: 12px;
                        left: 0;
                        margin-top: 13px;
                        width: 10px;
                        height: 10px;
                        border-radius: 50%;
                        box-sizing: content-box;
                        background-color: ${hover};
                    }
                }

            }

            .video-box {
                position: relative;
                //cursor: pointer;
                margin-top: 30px;
                width: 100%;
                margin-bottom: 60px;

                img {
                    width: 100%;

                }

                .hover-btn {
                    height: 80px;
                    width: 80px;
                    background-color: white;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: absolute;
                    z-index: 2;
                    top: 0;
                    bottom: 0;
                    margin: auto;
                    left: 0;
                    right: 0;

                    &.hover:after {
                        border-radius: 50%;
                    }

                    svg {
                        position: relative;
                        z-index: 2;
                    }

                    path {
                        transition: all .3s ease;
                    }

                    &:hover {

                        &:after {
                            height: 100%;
                            width: 100%;
                        }

                        path {
                            fill: #FFF;
                        }
                    }

                }


            }


        }

    }


    @media (max-width: 767px) {

        //margin-bottom: 80px;
        .detail-page__heading__tags {
            flex-wrap: wrap;

            ul {
                min-width: 100%;
                margin-bottom: 20px;
            }

            p {
                min-width: 100%;
            }
        }

        .detail-page__text-content__share {
            margin-bottom: 60px;
            min-width: 100%;

            ul {
                display: flex;

                li {
                    margin-right: 10px;
                }
            }
        }

        .detail-page__text-content__detail {
            min-width: 100%;
        }
    }
    //.sticky-inner-wrapper{
    //  top:120px !important;
    //}
    @media (max-width: 767px) {
        .title h2 {
            text-align: start !important;
        }
    }
`;

export default MyComponent;
